import { environment } from "./../../../../environments/environment";
import { Utils } from "./../../helper/utils";
import { Location } from "@angular/common";
import { StorageService } from "@core/services/storage.service";
import { Component, OnInit, OnDestroy, NgZone } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ServiceLocator } from "../../services/locater.service";
import { Subscription } from "rxjs";
import { CurrencyEnum } from "../../enumeration/CurrencyEnum";
import ar from "@angular/common/locales/ar";
import { registerLocaleData } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { LookupEnums } from "@shared/enumeration/LookupEnum";
import { AbstractRestService } from "@shared/services/abstract.service";
import { BreadcrumbService } from "@shared/services/breadcrumb.service";
import { NgxSpinnerService } from "ngx-spinner";
import { AlertifyService } from "@core/services/alertify.service";
import { SharedService } from "@core/services/shared.service";
import { Validators } from "@angular/forms";
@Component({
  selector: "app-base",
  templateUrl: "./base.component.html",
  styleUrls: ["./base.component.css"],
})
export class BaseComponent implements OnInit, OnDestroy {
  ImageRemoved: boolean = true;
  ownerRoleId: number = 4;
  MconnectDisplay: Boolean = true
  spinnerngx: NgxSpinnerService;
  displayPhoneNumber: Boolean = false;
  Creditline: Boolean = false;
  sharedService: SharedService;
  Ticketing: Boolean = true;
  loaderInput: Boolean = false;
  loading: boolean = true;
  CalculateFees: Boolean = true;
  languages: any[] = [
    { symbol: 'en', title: 'En' },
    { symbol: 'ar', title: 'Ar' }
  ];
  public subscriptions: Subscription[] = [];
  selectedLanguage: string

  recharge;
  createinv;
  report;
  catalogue;
  topup;
  payroll;
  IsNotVerified: Boolean;
  isReadOnly: Boolean;
  rest;
  reser;
  currentCountry: string = 'LB';
  static staticSelectedCurrency: string = LookupEnums.CurrencyEnum.USD.toString();
  static staticSelectedCurrencyText: string = "USD";
  picturePath: string =
    window.origin + "/api/matensa/profileimage/ImageNameForReplace";
  // shareddata: SharedDataService;
  translate: TranslateService;
  breadcrumbService: BreadcrumbService;
  router: Router;
  activatedRoute: ActivatedRoute;
  location: Location;
  isLogged: Boolean = true;
  alertify: AlertifyService;
  linkPicture: string;
  pageTitle: string = "";
  fields: Object = { text: "Text", value: "Id" };
  selectTranslated: string;
  showLoading: boolean = true;
  ReminderCategories: any[] = [];
  ReminderTypes: any[] = [];
  breadcrumbs: { label: string; url: string }[] = [];
  storageService: StorageService;

  constructor(

    protected _abstractService?: AbstractRestService<any>
  ) {
    this.breadcrumbService = ServiceLocator.getInjector().get(BreadcrumbService);
    this.translate = ServiceLocator.getInjector().get(TranslateService);
    this.sharedService = ServiceLocator.getInjector().get(SharedService);
    this.alertify = ServiceLocator.getInjector().get(AlertifyService);
    this.storageService = ServiceLocator.getInjector().get(StorageService);
    this.router = ServiceLocator.getInjector().get(Router);
    this.activatedRoute = ServiceLocator.getInjector().get(ActivatedRoute);
    this.location = ServiceLocator.getInjector().get(Location);
    let currentSelectedLang: string = this.languages[0].symbol;
    if (
      typeof this.storageService.getLocalStorage("selected_language") !=
      "undefined" &&
      this.storageService.getLocalStorage("selected_language") != null
    ) {
      currentSelectedLang = this.storageService.getLocalStorage("selected_language");
      if (Utils.isNullOrUndefinedOrEmpty(currentSelectedLang)) {
        this.storageService.removeLocalStorage("selected_language");
        currentSelectedLang = this.languages[0].symbol;
        this.storageService.setLocalStorage("selected_language", currentSelectedLang);
      }
    }
    this.selectedLanguage = currentSelectedLang;
    this.useLanguage(currentSelectedLang);
    registerLocaleData(ar);

    this.subscriptions.push(
      this.sharedService._selectedLanguage$.subscribe((x) => {
        if (typeof x != "undefined" && x != null && x.length > 0) {
          this.useLanguage(x);
        }
      })
    );
    this.sharedService.isLoading.subscribe(state => {
      this._spinner = state
    });
    this.sharedService.withLoader.subscribe(state => {
      this._withLoader = state
    });
    if (this.spinnerngx) {
      this.spinnerngx.show();
    }

  }
  _spinner: boolean = true;
  _withLoader: boolean = true;
  get spinner() {
    return this._spinner
  }
  get withLoader() {
    return this._withLoader
  }
  ngOnInit() {
    console.log('fffffsss');
    console.log(this.breadcrumbService);
    if (!Utils.isNullOrUndefinedOrEmpty(this._abstractService))
      this.subscriptions.push(
        this._abstractService.loading$.subscribe((x) => {
          // setTimeout(() => {
          this.showLoading = x;
          //}, 2000);
        })
      );
    // this.requestPermission();
    // this.listen();
  }
  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());

  }

  generateForm(fields) {
    const group: any = {};

    // Loop through each field and dynamically create the controls with validators
    fields.forEach((field) => {
      const validators = [];
      field.validators.forEach((validator) => {
        if (validator.type === 'required') {
          validators.push(Validators.required);
        } else if (validator.type === 'minlength') {
          validators.push(Validators.minLength(validator.value));
        } else if (validator.type === 'pattern') {
          validators.push(Validators.pattern(validator.value));
        }
      });

      group[field.name] = ['', validators]; // Initialize each control with an empty string and validators
    });

    return group;

    // this.dynamicForm = this.fb.group(group); // Create the form group
  }

  displaySuccessMessage(arr, msg: any = "") {
    const field = Utils.getFieldMessage(arr);

    // Check if 'field' is a valid string (not undefined or null)
    if (typeof field === 'string' && field in arr) {
      const message = Utils.setMessage(arr[field]);
      this.alertify.success(message);
    } else {
      this.alertify.success(msg);
    }
  }
  subscribeLoading(services: AbstractRestService<any>[]) {
    if (services && services.length > 0)
      services.forEach((service) => {
        this.subscriptions.push(
          service.getLoading().subscribe((x) => {
            this.showLoading = x;
          })
        );
      });
  }

  useLanguage(language: string) {
    this.translate.setDefaultLang(language);
    this.storageService.setLocalStorage('lang', language);
    //this.sharedService.setSelectedLanguage(language);
    if (language == "ar")
      document.querySelector("body").classList.add("rtl");
    else document.querySelector("body").classList.remove("rtl");
    this.selectedLanguage = language;
    this.translate.use(language);

  }
  setLoginData(userObj) {
    if (!Utils.isNullOrUndefinedOrEmpty(userObj)) {
      const currentTimePlusHalfHour = new Date(
        new Date().setMinutes(
          new Date().getMinutes() + parseInt(environment.sessionLife)
        )
      ).getTime();
      this.storageService.setSessionStorage(
        "valid_token",
        currentTimePlusHalfHour.toString()
      );
      this.storageService.setStorage('IsPersonal', 1);
      this.storageService.setLocalStorage("isFromLogin", true);
      this.sharedService.setLoggedInUser(userObj);
    }
  }
}
